import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { IconMail } from '@tabler/icons-react';
import { authApi } from 'api/authApi';
import { toast } from 'react-toastify';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (!email) {
      setError('Please enter your email address');
      return;
    }
    if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(email)) {
      setError('Please enter a valid email address');
      return;
    }

    setLoading(true);
    try {
      await authApi.forgotPassword({ email });
      setSubmitted(true);
      toast.success('Password reset link sent!');
    } catch (err) {
      const message = err?.response?.data?.message || 'Failed to send reset link. Please try again.';
      setError(message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-container">
        <div className="login-card">
          <div className="login-card__brand">
            <h1 className="login-card__title">Forgot Password</h1>
            <p className="login-card__subtitle">We&rsquo;ll email you a reset link</p>
          </div>

          <div className="login-card__divider" />

          {!submitted ? (
            <form onSubmit={handleSubmit} className="login-card__form">
              <div className="login-field">
                <label className="login-field__label" htmlFor="forgot-email">Email Address</label>
                <div className="login-field__input-wrap">
                  <IconMail size={18} className="login-field__icon" />
                  <input
                    id="forgot-email"
                    type="email"
                    placeholder="you@company.com"
                    value={email}
                    onChange={(e) => { setEmail(e.target.value); setError(''); }}
                    autoComplete="email"
                    className={`login-field__input ${error ? 'login-field__input--error' : ''}`}
                  />
                </div>
                {error && <span className="login-field__error">{error}</span>}
              </div>

              <button type="submit" className="login-card__btn" disabled={loading}>
                {loading ? 'Sending…' : 'Send Reset Link'}
              </button>

              <div style={{ textAlign: 'center', marginTop: '18px' }}>
                <Link to="/login" style={{ color: '#5c6b73', fontSize: '13px', textDecoration: 'none', fontWeight: 600 }}>
                  ← Back to Login
                </Link>
              </div>
            </form>
          ) : (
            <div style={{ textAlign: 'center', padding: '12px 0' }}>
              <div style={{ fontSize: '48px', marginBottom: '12px' }}>📧</div>
              <h3 style={{ fontWeight: 700, marginBottom: '8px' }}>Check Your Email</h3>
              <p style={{ color: '#5c6b73', fontSize: '14px', lineHeight: '1.6' }}>
                A reset link has been sent to <strong>{email}</strong>. The link expires in 10 minutes.
              </p>
              <Link to="/login" className="login-card__btn" style={{ display: 'inline-block', lineHeight: '48px', textDecoration: 'none', marginTop: '16px', width: 'auto', padding: '0 32px' }}>
                Back to Login
              </Link>
            </div>
          )}

          <p className="login-card__footer">
            &copy; {new Date().getFullYear()} SiteSync &middot; All rights reserved
          </p>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
